const initialState = {
  rfqs: [],
  rfqsLoaded: false,
  loading: false,
};

const rfqKey = (rfq) => String(rfq?.POID ?? rfq?.id ?? "");

const hasRfqLines = (rfq) =>
  Array.isArray(rfq?.lineItems) && rfq.lineItems.length > 0;

const hasRfqVendors = (rfq) =>
  Array.isArray(rfq?.vendors) && rfq.vendors.length > 0;

/** Prefer richer lines/vendors so list/Sync replace don't wipe hole-filled detail. */
const mergeRfqPreserveDetail = (existing, incoming) => {
  if (!incoming) return existing || null;
  if (!existing) return incoming;
  const keepLines =
    !hasRfqLines(incoming) && hasRfqLines(existing)
      ? existing.lineItems
      : incoming.lineItems;
  const keepVendors =
    !hasRfqVendors(incoming) && hasRfqVendors(existing)
      ? existing.vendors
      : incoming.vendors;
  const keepFetched = Boolean(existing.__detailFetched || incoming.__detailFetched);
  return {
    ...existing,
    ...incoming,
    lineItems: keepLines ?? existing.lineItems ?? incoming.lineItems ?? [],
    vendors: keepVendors ?? existing.vendors ?? incoming.vendors ?? [],
    ...(keepFetched ? { __detailFetched: true } : {}),
  };
};

const rfqsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_RFQS": {
      const incoming = Array.isArray(action.payload) ? action.payload : [];
      const prevById = new Map((state.rfqs || []).map((r) => [rfqKey(r), r]));
      const rfqs = incoming.map((r) => {
        const id = rfqKey(r);
        if (!id || id === "null") return r;
        return mergeRfqPreserveDetail(prevById.get(id), r);
      });
      return { ...state, rfqs, rfqsLoaded: true, loading: false };
    }

    case "UPSERT_RFQ": {
      const incoming = action.payload;
      if (!incoming) return state;
      const id = rfqKey(incoming);
      if (!id || id === "null") return state;
      const existing = (state.rfqs || []).find((r) => rfqKey(r) === id);
      const merged = mergeRfqPreserveDetail(existing, incoming);
      const rfqs = existing
        ? (state.rfqs || []).map((r) => (rfqKey(r) === id ? merged : r))
        : [merged, ...(state.rfqs || [])];
      return { ...state, rfqs, rfqsLoaded: true, loading: false };
    }

    default:
      return state;
  }
};

export default rfqsReducer;
export { mergeRfqPreserveDetail, hasRfqLines };
